import { useAppSelector } from "app/redux/hooks";
import { ProfissionalComissoes } from "app/types/comissoes/Profissionais";
import { IOrcamento } from "app/types/IOrcamento";
import { tratamentoErroPadrao } from "app/use-cases";
import { removerProfissionais, salvarProfissionais } from "app/use-cases/orcamento/comissoes/profissionais";
import globalMU from "globalMU";
import React, { useEffect, useState } from "react"
import { DadosInclusaoEdicaoAbaProfissionais, InclusaoEdicaoAbaProfissionais } from "./InclusaoEdicaoAbaProfissionais"

export type InclusaoEdicaoAbaProfissionaisContainerProps = {
    onAlteradoDadosInclusaoEdicaoAbaProfissionais: (dados: DadosInclusaoEdicaoAbaProfissionais) => void;
    onDesativarIncluirProfissional: (semProfissionaisAdiconados: boolean) => void;
}

export const InclusaoEdicaoAbaProfissionaisContainer = (props: InclusaoEdicaoAbaProfissionaisContainerProps & DadosInclusaoEdicaoAbaProfissionais) => {
    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)
    const [profissionais, setProfissionais] = useState<ProfissionalComissoes[]>(orcamento.Profissionais);

    const onExcluirProfissionais = async (profissionais: ProfissionalComissoes[]) => {
        try {
            globalMU.blockUI();
            const resultado = await removerProfissionais(profissionais)
            if (!("HasErrors" in resultado) && resultado.Profissionais != null) {
                globalMU.showSuccessMessage("Profissional(is) excluído(s) com sucesso")
            } else if (!("HasErrors" in resultado) && resultado.Profissionais == null) {
                props.onDesativarIncluirProfissional(true);
                globalMU.showSuccessMessage("Profissional(is) excluído(s) com sucesso")
            } else {
                props.onDesativarIncluirProfissional(true);
            }
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const onSalvarProfissionais = async (profissionais: ProfissionalComissoes[]) => {
        try {
            globalMU.blockUI();
            const profissionaisComExterno = profissionais.map(p => ({...p, Externo: props.listaProfissionaisTipo[p.Codigo] == undefined ? p.Externo : props.listaProfissionaisTipo[p.Codigo] == "Externo" ? true : false }))
            const resultado = await salvarProfissionais(profissionaisComExterno)
            if (!("HasErrors" in resultado) && resultado.Profissionais != null) {
                setProfissionais(resultado.Profissionais)
                globalMU.showSuccessMessage("Profissional(is) atualizado(s) com sucesso")
            }
            
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    useEffect(() => {
        setProfissionais(orcamento.Profissionais);
    }, [orcamento.Profissionais])


    return (
        <>
            <InclusaoEdicaoAbaProfissionais
                listaProfissionaisTipo={props.listaProfissionaisTipo}
                profissionaisSelecionados={props.profissionaisSelecionados}
                listarProfissionais={profissionais}
                colorBackgroundSelecionadaInclusaoEdicao={globalMU.sessionStorage.getData('UsuarioLogado')?.CorFundo}
                colorTextoSelecionadaInclusaoEdicao={globalMU.sessionStorage.getData('UsuarioLogado')?.CorTexto}
                onAlteradoDadosInclusaoEdicaoAbaProfissionais={props.onAlteradoDadosInclusaoEdicaoAbaProfissionais}
                onAplicar={onSalvarProfissionais}
                onInserir={props.onDesativarIncluirProfissional}
                onExcluir={onExcluirProfissionais}
            />
        </>
    )

}

 